module.exports = __webpack_public_path__ + "static/media/xray-training-lateral-nonflex1.8fa8eac1.png";